import React from 'react'


class DraggableG extends React.Component {


    onDragOver = (e) => {
        // console.log("HEE")
        // e.preventDefault()

        // if (!this.state.isDragging) {
        // console.log("DragOVER")
        e.preventDefault()
        // this.setState({ isDraggingOver: false })

        this.props.dragOver(this.props.id)
        // }

        // setIsOnDragOver(true)
    }


    onDragStart = (e) => {
        // e.preventDefault()
        // console.log(e)
        // e.dataTransfer.setDragImage(this.draggableItem,0,0);
        // console.log(this.draggableItem)
        e.dataTransfer.setData('id', this.props.id)
        this.props.dragStarted(this.props.id)
        // this.setState({ isDragging: true })
        // this.dragIndicator.addClass('hide')

        // console.log(this.props.id)

        // this.props.cloneRow(row.current)
    }

    onDrop = (e) => {
        // e.preventDefault()
        let id = e.dataTransfer.getData('id', this.props.id)
        this.props.onDrop(id)

        // console.log("DROP")
        // console.log(id)
    }

    onDragEnd = (e) => {
        this.props.dragEnd(e)

        // this.dragIndicator.removeClass('hide')
    }

    render() {

        var children = []
        if (Array.isArray(this.props.children)) {
            var children = this.props.children.map(function (child, i) {
                if (typeof child == 'object') {
                    // if (((typeof this.state.stage == 'string') && (child.props.stageName === this.state.stage)) || ((typeof this.state.stage == 'number') && (child.props.stage === this.state.stage)) || child.props.stage === null) {
                    return React.cloneElement(child,
                        { key: i, onDragStart: this.onDragStart, onDrag: this.props.onDrag }
                    )
                    // }
                    // return
                }
            }, this);

        } else {
            var children = React.cloneElement(this.props.children,
                { onDragStart: this.onDragStart, onDrag: this.props.onDrag }
            )

        }

        // console.log(children)

        // var propchildren = Array.isArray(this.props.children) ? this.props.children : [this.props.children]
        // if (Array.isArray(this.props.children)) {
        // children = propchildren.map(function (child, i) {

        //     return (
        //         <>
        //             {React.cloneElement(child,
        //                 { key: child.key, onDragStart: this.onDragStart, onDrag: this.props.onDrag }
        //             )}

        //         </>
        //     )

        // }, this);
        // }

        return (
            <div className={"draggable-component " + (this.props.col ?? "col-12 col-md-6 col-lg-4") + ' ' + this.props.extraClass} ref={el => this.draggableItem = el} onDrop={e => this.onDrop(e, 'complete')} onDragOver={e => this.onDragOver(e)} onDragEnd={e => this.onDragEnd(e)} >

                {children}

                {/* <div className={"drag-indicator"} draggable onDragStart={e => this.onDragStart(e)} onDrag={e => this.props.onDrag(e)} >

                </div> */}

            </div>
        )
    }

}

export default DraggableG
